import { render } from "./Spawns.vue?vue&type=template&id=360938d6"
import script from "./Spawns.vue?vue&type=script&lang=js"
export * from "./Spawns.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__